import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { theme } from "../../../../utils/global-styles/theme";

const LeftSliderArrow = ({ arrowBgColorClassName, handleArrowClick }) => {
  const [isCurrentlyHoveredOver, setIsCurrentlyHoveredOver] = useState(false);

  const LeftArrow = styled.svg`
    cursor: pointer;

    @media only screen and (max-width: ${theme.breakpoints.helper800}) {
      width: 60px;
      height: 60px;
    }

    @media only screen and (max-width: ${theme.breakpoints.mobile}) {
      width: 50px;
      height: 50px;
    }
  `;
  return (
    <LeftArrow
      width="92px"
      height="92px"
      viewBox="0 0 92 92"
      version="1.1"
      onMouseEnter={() => setIsCurrentlyHoveredOver(true)}
      onMouseLeave={() => setIsCurrentlyHoveredOver(false)}
      onClick={() => handleArrowClick("left")}
      className={
        isCurrentlyHoveredOver
          ? `svg-child-circle-fill-secondary path-white-fill`
          : `svg-child-circle-fill-${arrowBgColorClassName} path-secondary-fill`
      }
    >
      <g
        id="Icons-&amp;-Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icons" transform="translate(-40.000000, -808.000000)">
          <g
            id="Button/Carousel-Navigation/Left/Gray"
            transform="translate(40.000000, 808.000000)"
          >
            <circle
              id="Oval-Bg"
              fill={theme.colors.white}
              fillRule="evenodd"
              transform="translate(46.000000, 46.000000) scale(-1, 1) translate(-46.000000, -46.000000) "
              cx="46"
              cy="46"
              r="46"
            ></circle>
            <path
              d="M32.977221,27.9733965 C31.6742597,29.2656821 31.6742597,31.3532204 32.977221,32.645506 L45.9400152,45.5020911 L32.977221,58.3586763 C31.6742597,59.6509619 31.6742597,61.7385002 32.977221,63.0307858 C34.2801822,64.3230714 36.3849658,64.3230714 37.6879271,63.0307858 L53.022779,47.8215781 C54.3257403,46.5292925 54.3257403,44.4417542 53.022779,43.1494686 L37.6879271,27.940261 C36.4183751,26.6811109 34.2801822,26.6811109 32.977221,27.9733965 Z"
              id="Path"
              fill={theme.colors.secondary}
              fillRule="nonzero"
              transform="translate(43.000000, 45.500000) scale(-1, 1) translate(-43.000000, -45.500000) "
            ></path>
          </g>
        </g>
      </g>
    </LeftArrow>
  );
};
LeftSliderArrow.propTypes = {
  arrowBgColorClassName: PropTypes.string,
  handleArrowClick: PropTypes.func,
};

export default LeftSliderArrow;
